<template>
    <div class="video_h5D">
        <Header>
            <h4><span>{{$t('EndVideo')}}</span></h4>
        </Header>
       <aliPlayer :source="endVideo"></aliPlayer>
       <div class="test_submit">
            <div class="submit_done">
              <a class="sub" :class="{cur:cur_data.idx==1}" @click="videoOver">{{$t('prevChapter')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
import aliPlayer from 'components/aliPlayerHeadTail'
import Header from 'components/H5/Header.vue'

export default {
  name: 'Video',
  data () {
    return {

    }
  },
  computed: {
    cur_data () {
      return this.$store.state.cur_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    },
    video_finished () {
      return this.$store.state.video_finished
    }
  },
  created () {
    this.$store.commit('setScaleState', false)
  },
  methods: {
    videoOver () {
      let checkedChapterType = this.cur_data.chapter_type
      // 竖屏
      // debugger
      if (checkedChapterType == 1) {
        this.$router.replace('/h5Dindex/video')
      } else if (checkedChapterType == 4) {
        this.$router.replace('/h5Dindex/tuwen')
      } else {
        this.getChapterAnswer()// 取答案数据
        // this.$forceUpdate()
        this.$router.replace({ path: '/h5Dindex/test', query: { chapter_id: this.cur_data.chapter_id } })
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('setScaleState', true)
  },
  components: {
    aliPlayer,
    Header
  }
}
</script>
<style lang="less" scoped>
    .video_h5D {
       /*  padding:.2rem 1.2rem;
        .aliplayer {
            height: calc(100vh - 2.2rem);
        } */
        font-size:.26rem;
        .test_submit {
        padding:0.8rem 0.46rem 0.4rem;
        height: 2.2rem;
        box-sizing: border-box;
        .unsubmit {
          /*margin: 40px 0 20px;*/
          img {
            width: 0.22rem;
            height: 0.4rem;
            margin:0.28rem 0.24rem;
          }
          .sub,.next {
            display: inline-block;
            width:0.68rem;
            height:0.96rem;
            border:1px solid rgba(169, 174, 175, 1);
            border-radius:0.06rem;
            margin-right: 0.2rem;
            vertical-align: middle;
            &.yc {
              visibility: hidden;
            }
          }
          .next {
            float: right;
            margin-right: 0;
          }
          .submit {
            display: inline-block;
            width:4.7rem;
            height:1rem;
            background-color: @basic-color;
            border-radius:0.06rem;
            margin: 0 auto;
            font-size:0.3rem;
            color: #fff;
            text-align: center;
            line-height: 1rem;
            vertical-align: middle;
          }
        }
        .submit_done {
          .sub {
            color: @basic-color;
            background-color: #fff;
          }
          .next {
            color: @basic-color;
            background-color: #fff;
            float: right;
          }
          .sub,.next {
            width:3.12rem;
            border:1px solid @basic-color;
            border-radius:0.06rem;
            text-align: center;
            line-height: .78rem;
            display: inline-block;
            font-size: 0.32rem;
            &.cur {
              border:1px solid #ccc;
              color: #ccc;
              opacity:.8;
            }
          }

        }
      }

    }
</style>
